import { App, LinkMenuItem, WidgetOperationTypes } from '@openedx/frontend-base';

import { faqRole, ansRole, dashboardRole } from '../../constants';

const app: App = {
  appId: 'org.openedx.frontend.app.template.exampleHeader',
  slots: [
  ],
};

export default app;
